module.exports = __webpack_public_path__ + "static/img/新logo@2x.5755bf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/新logo@2x.png
// module id = cf7I
// module chunks = 34